import { Box, Stack, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";

const TooltipStack = ({ 
  items = [],
  backgroundColor = 'rgb(255, 193, 7)',
  labelColor = (theme) => (theme.palette.text.light.primary),
  valueColor = (theme) => (theme.palette.text.light.primary),
  valueTransformFn,
}) => (
  <Stack>
    { 
      items.map(({ label, value }) => (
        <Box
          sx={{
            backgroundColor: alpha(backgroundColor, 0.1),
            borderRadius: '4px',
            py: 0.5,
            px: 1,
            mb: 0.5,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            border: `1px solid ${alpha(backgroundColor, 0.2)}`,
          }}
        >
          <Typography 
            sx={(theme) => ({ 
              color: labelColor,
              fontSize: 14, 
            })}
          >
            {label}:
          </Typography>
          <Typography 
            sx={(theme) => ({ 
              color: valueColor,
              fontSize: 14, 
            })}
          >
            { valueTransformFn ? valueTransformFn(value) : value }
          </Typography>
        </Box>
      ))}
  </Stack>
)

export default TooltipStack;